import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderAppComponent } from './loader-app/loader-app.component';
import { IonicModule } from '@ionic/angular';
import { QRCodeModule } from 'angularx-qrcode';
import { LoaderCoverComponent } from './loader-cover/loader-cover.component';
import { RouterModule } from '@angular/router';
import { FilterLabelComponent } from './filter-label/filter-label.component';
import { ZFIcon } from './zf-icon/zf.icon';
import { TableComponent } from './table/table.component';
import { FilterComponent } from './filter/filter.component';
import { LabelComponent } from './filter/label/label.component';
import { SelectComponent } from './tags/select/select.component';
import { CheckboxComponent } from './tags/checkbox/checkbox.component';
import { BaseTableComponent } from './table/base-table/base-table.component';
import { CustomButtonComponent } from './custom-button/custom-button.component';
import { DefaultErrorModalComponent } from './default-error-modal/default-error-modal.component';
import { DefaultInfoModalComponent } from './default-info-modal/default-info-modal.component';
import { NewFeatureTooltip } from './new-feature-tooltip/new-feature-tooltip.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { UploadFileSummaryComponent } from './upload-file-summary/upload-file-summary.component';
import { AppSelectComponent } from './activation/app-select/app-select.component';
import { LandingComponent } from './activation/landing/landing.component';
import { PreConfigurationComponent } from './activation/pre-configuration/pre-configuration.component';
import { BundleSelectionComponent } from './input-app/bundle-selection/bundle-selection.component';
import { ComponentsDiscriptorComponent } from './input-app/components-discriptor/components-discriptor.component';
import { MultiSelectComponent } from './input-app/multi-select/multi-select.component';
import { SizeSelectionComponent } from './input-app/size-selection/size-selection.component';
import { FormsModule } from '@angular/forms';
import { ClickTrackingComponent } from './common/click-tracking/click-tracking.component';
import { NumberPadComponent } from './common/number-pad/number-pad.component';
import { TileComponent } from './tile/tile.component';
import { SearchFilterComponent } from './tags/search-filter/search-filter.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { ListingPaginationComponent } from './listing-pagination/listing-pagination.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ListingSorterComponent } from './listing-sorter/listing-sorter.component';
import { MultiSelectPopoverDeprComponent } from './multi-select-popover-depr/multi-select-popover-depr.component';
import { SingleSelectMobileComponent } from './single-select-mobile/single-select-mobile.component';
import { MmMobileModalHeaderComponent } from './mm-mobile-modal-header/mm-mobile-modal-header.component';
import { MmWebModalHeaderComponent } from './mm-web-modal-header/mm-web-modal-header.component';
import { DurationPickerComponent } from './duration-picker/duration-picker.component';
import { InlineMultiSelectDeprComponent } from './inline-multi-select-depr/inline-multi-select-depr.component';
import { KeyPadComponent } from './key-pad/key-pad.component';
import { KeyBoardComponent } from './key-board/key-board.component';
import { LazyLoadingComponentComponent } from './lazy-loading-component/lazy-loading-component.component';
import { RenderOnView } from './ui-directives/render-on-view';
import { ClickOutsideDirective } from './ui-directives/click-outside-directive';
import { OrgHeirarchyComponent } from './org-heirarchy/org-heirarchy.component';
import { GradingPageComponent } from './input-app/md-point/grading-page/grading-page.component';
import { BctxHeaderComponent } from './input-app/md-point/bctx-header/bctx-header.component';
import { SizeFilterComponent } from './input-app/md-point/size-filter/size-filter.component';
import { BulkCountPadComponent } from './input-app/md-point/bulk-count-pad/bulk-count-pad.component';
import { WipValidationErrorModalComponent } from './input-app/md-point/wip-validation-error-modal/wip-validation-error-modal.component';
import { ToBeRectifiedErrorModalComponent } from './input-app/md-point/to-be-rectified-error-modal/to-be-rectified-error-modal.component';
import { FormComponent } from './form/form.component';
import { IssueSelectionComponent } from './input-app/issue-selection/issue-selection.component';
import { MarkLocationComponent } from './input-app/mark-location/mark-location.component';
import { OperationOrRejectReasonSelectionComponent } from './input-app/operation-or-reject-reason-selection/operation-or-reject-reason-selection.component';
import { DefectiveFlowContainerComponent } from './input-app/defective-flow-container/defective-flow-container.component';
import { RangeComponentComponent } from './input-app/range-component/range-component.component';
import { ErrorModalComponent } from './input-app/md-point/error-modal/error-modal.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { ViewMoreListModalComponent } from './view-more-list-modal/view-more-list-modal.component';
import { StatusHeaderComponent } from './status-header/status-header.component';
import { AccordionTableComponent } from './accordion-table/accordion-table.component';
import { TableRowPopoverComponent } from './table-row-popover/table-row-popover.component';
import { SingleSelectPopoverComponent } from './single-select-popover/single-select-popover.component';
import { InlineSingleSelectComponent } from './inline-single-select/inline-single-select.component';
import { MultiSelectDropdownComponent } from './common/multi-select-dropdown/multi-select-dropdown.component';
import { BctxSelectionComponent } from './input-app/bctx-selection/bctx-selection.component';

import { CompletionModalComponent } from './input-app/roaming-qc/completion-modal/completion-modal.component';
import { ListingLayoutComponent } from './listing-layout/listing-layout.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { TimelineComponent } from './timeline/timeline.component';

import { CalendarModule } from 'ion7-calendar';
import { CalendarComponent } from './calendar/calendar.component';
import { EditableListComponent } from './editable-list/editable-list.component';
import { FilterMasterdataListComponent } from './input-app/filter-masterdata-list/filter-masterdata-list.component';
import { BleModeComponent } from './input-app/ble-mode/ble-mode.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslationLoaderFactory } from '@monorepo/services';
import { LoaderOverlayComponent } from './loader-overlay/loader-overlay.component';
import { StatusTileComponent } from './status-tile/status-tile.component';
import { FilterModalComponent } from './filter/filter-modal/filter-modal.component';
import { SearchbarWithAPISuggestionsContainerComponent } from './searchbar-with-api-suggestions-container/searchbar-with-api-suggestions-container.component';

import { BulkCountLandingComponent } from './input-app/bulk-count/bulk-count-landing/bulk-count-landing.component';
import { BulkCountGradingPageComponent } from './input-app/bulk-count/bulk-count-grading-page/bulk-count-grading-page.component';
import { VendorSelectionComponent } from './input-app/bulk-count/vendor-selection/vendor-selection.component';
import { GradingPageExitComponent } from './input-app/grading-page-exit/grading-page-exit.component';
import { ValidationErrorModalComponent } from './input-app/bulk-count/validation-error-modal/validation-error-modal.component';
import { MultiSelectPopoverComponent } from './multi-select-popover/multi-select-popover.component';
import { InlineMultiSelectComponent } from './inline-multi-select/inline-multi-select.component';
import { SilhouetteComponent } from './common/silhouette/silhouette.component';
import { SilhouetteMarkerComponent } from './common/silhouette-marker/silhouette-marker.component';
import { TagDisplayComponent } from './tag-display/tag-display.component';
import { TagHistoryModalComponent } from './input-app/tag-history-modal/tag-history-modal.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { IssueCategoryFilterComponent } from './input-app/md-point/issue-category-filter/issue-category-filter.component';
import { RejectSelectionV2Component } from './input-app/reject-selection-v2/reject-selection-v2.component';
import { RejectV2MultiSelectComponent } from './input-app/reject-v2-multi-select/reject-v2-multi-select.component';
import { FilterRejectV2ListComponent } from './input-app/filter-reject-v2-list/filter-reject-v2-list.component';
import { DefectiveFlowContainerV3Component } from './input-app/defective-flow-container-v3/defective-flow-container-v3.component';
import { IssueSelectionV3Component } from './input-app/issue-selection-v3/issue-selection-v3.component';
import { OperationSelectionV3Component } from './input-app/operation-selection-v3/operation-selection-v3.component';
import { AppUpdatesComponent } from './app-updates/app-updates.component';
import { InspectionCompletionSuccessPopupComponent } from './inspection-completion-success-popup/inspection-completion-success-popup.component';
import { EnterTagModalComponent } from './input-app/cutbank/enter-tag-modal/enter-tag-modal.component';
import { LineSelectionModalComponent } from './input-app/cutbank/line-selection-modal/line-selection-modal.component';
import { LinesComponent } from './input-app/cutbank/lines/lines.component';
import { UpdateQtyModalComponent } from './input-app/cutbank/update-qty-modal/update-qty-modal.component';
import { BundleTagDetailsComponent } from './input-app/cutbank/bundle-tag-details/bundle-tag-details.component';
import { ExpandBundleTagDetailsModalComponent } from './input-app/cutbank/expand-bundle-tag-details-modal/expand-bundle-tag-details-modal.component';
import { EmbFailureComponent } from './input-app/embellishment/emb-failure/emb-failure.component';
import { EmbSuccessComponent } from './input-app/embellishment/emb-success/emb-success.component';
import { FractionalPadComponent } from './common/fractional-pad/fractional-pad.component';

import { GroupedBctxListingComponent } from './input-app/grouped-bctx-listing/grouped-bctx-listing.component';
import { LoginBackgroundComponent } from './input-app/login-background/login-background.component';
import { BulkActionComponent } from './bulk-action/bulk-action.component';
import { MobileListingPaginationComponent } from './mobile-listing-pagination/mobile-listing-pagination.component';
import { NgxPrintModule } from 'ngx-print';
import { ComponentTagHistoryComponent } from './input-app/component-tag-history/component-tag-history.component';
import { SingleAndMultiSelectComponent } from './input-app/single-and-multi-select/single-and-multi-select.component';
import { DateFilterComponent } from './date-filter/date-filter.component';
import { NpsFormComponent } from './nps/nps-form/nps-form.component';
import { NpsEmojiFeedbackComponent } from './nps/components/nps-emoji-feedback/nps-emoji-feedback.component';
import { UpdateReadpowerModalComponent } from './device-management/update-readpower-modal/update-readpower-modal.component';
import { IncreaseDecreaseInputComponent } from './increase-decrease-input/increase-decrease-input.component';
import { AppUpdateModalComponent } from './app-update-modal/app-update-modal.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule,
    QRCodeModule,
    NgxPrintModule,
    CalendarModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          const factory = new TranslationLoaderFactory(http);
          return factory.createForApp('ui');
        },
        deps: [HttpClient],
      },
    }),
    ScrollingModule,
  ],
  declarations: [
    LoaderAppComponent,
    LoaderCoverComponent,
    SingleSelectPopoverComponent,
    FilterLabelComponent,
    ZFIcon,
    TableComponent,
    FilterComponent,
    LabelComponent,
    SelectComponent,
    CheckboxComponent,
    BaseTableComponent,
    CustomButtonComponent,
    DefaultErrorModalComponent,
    DefaultInfoModalComponent,
    NewFeatureTooltip,
    UploadFileComponent,
    UploadFileSummaryComponent,
    LandingComponent,
    AppSelectComponent,
    PreConfigurationComponent,
    BundleSelectionComponent,
    ComponentsDiscriptorComponent,
    SizeSelectionComponent,
    MultiSelectComponent,
    ClickTrackingComponent,
    NumberPadComponent,
    ListingPaginationComponent,
    PaginationComponent,
    ListingSorterComponent,
    TileComponent,
    SearchFilterComponent,
    ConfirmationModalComponent,
    MultiSelectPopoverDeprComponent,
    SingleSelectMobileComponent,
    MmMobileModalHeaderComponent,
    MmWebModalHeaderComponent,
    DurationPickerComponent,
    InlineMultiSelectDeprComponent,
    KeyPadComponent,
    KeyBoardComponent,
    RenderOnView,
    LazyLoadingComponentComponent,
    FormComponent,
    OrgHeirarchyComponent,
    GradingPageComponent,
    BctxHeaderComponent,
    SizeFilterComponent,
    BulkCountPadComponent,
    WipValidationErrorModalComponent,
    ToBeRectifiedErrorModalComponent,
    CompletionModalComponent,
    ClickOutsideDirective,
    IssueSelectionComponent,
    MarkLocationComponent,
    OperationOrRejectReasonSelectionComponent,
    DefectiveFlowContainerComponent,
    RangeComponentComponent,
    ErrorModalComponent,
    TooltipComponent,
    ViewMoreListModalComponent,
    StatusHeaderComponent,
    AccordionTableComponent,
    TableRowPopoverComponent,
    InlineSingleSelectComponent,
    MultiSelectDropdownComponent,
    ListingLayoutComponent,
    DropdownComponent,
    CalendarComponent,
    EditableListComponent,
    BctxSelectionComponent,
    FilterMasterdataListComponent,
    BleModeComponent,
    LoaderOverlayComponent,
    TimelineComponent,
    StatusTileComponent,
    FilterModalComponent,
    SearchbarWithAPISuggestionsContainerComponent,
    BulkCountLandingComponent,
    BulkCountGradingPageComponent,
    VendorSelectionComponent,
    GradingPageExitComponent,
    ValidationErrorModalComponent,
    MultiSelectPopoverComponent,
    InlineMultiSelectComponent,
    SilhouetteComponent,
    SilhouetteMarkerComponent,
    TagDisplayComponent,
    TagHistoryModalComponent,
    IssueCategoryFilterComponent,
    RejectSelectionV2Component,
    RejectV2MultiSelectComponent,
    FilterRejectV2ListComponent,
    DefectiveFlowContainerV3Component,
    IssueSelectionV3Component,
    OperationSelectionV3Component,
    AppUpdatesComponent,
    FractionalPadComponent,
    InspectionCompletionSuccessPopupComponent,
    EnterTagModalComponent,
    EmbFailureComponent,
    EmbSuccessComponent,
    LineSelectionModalComponent,
    LinesComponent,
    UpdateQtyModalComponent,
    BundleTagDetailsComponent,
    ExpandBundleTagDetailsModalComponent,
    GroupedBctxListingComponent,
    LoginBackgroundComponent,
    BulkActionComponent,
    MobileListingPaginationComponent,
    ComponentTagHistoryComponent,
    SingleAndMultiSelectComponent,
    DateFilterComponent,
    NpsFormComponent,
    NpsEmojiFeedbackComponent,
    UpdateReadpowerModalComponent,
    IncreaseDecreaseInputComponent,
    AppUpdateModalComponent,
  ],
  exports: [
    LoaderAppComponent,
    LoaderCoverComponent,
    SingleSelectPopoverComponent,
    FilterLabelComponent,
    ZFIcon,
    TableComponent,
    FilterComponent,
    EmbFailureComponent,
    EmbSuccessComponent,
    LabelComponent,
    SelectComponent,
    CheckboxComponent,
    BaseTableComponent,
    CustomButtonComponent,
    DefaultErrorModalComponent,
    DefaultInfoModalComponent,
    NewFeatureTooltip,
    UploadFileComponent,
    UploadFileSummaryComponent,
    LandingComponent,
    AppSelectComponent,
    PreConfigurationComponent,
    BundleSelectionComponent,
    ComponentsDiscriptorComponent,
    SizeSelectionComponent,
    MultiSelectComponent,
    ClickTrackingComponent,
    NumberPadComponent,
    FractionalPadComponent,
    ListingPaginationComponent,
    PaginationComponent,
    ListingSorterComponent,
    TileComponent,
    ConfirmationModalComponent,
    MultiSelectPopoverDeprComponent,
    SingleSelectMobileComponent,
    MmMobileModalHeaderComponent,
    MmWebModalHeaderComponent,
    DurationPickerComponent,
    KeyPadComponent,
    KeyBoardComponent,
    RenderOnView,
    LazyLoadingComponentComponent,
    FormComponent,
    OrgHeirarchyComponent,
    GradingPageComponent,
    BctxHeaderComponent,
    SizeFilterComponent,
    BulkCountPadComponent,
    WipValidationErrorModalComponent,
    ToBeRectifiedErrorModalComponent,
    CompletionModalComponent,
    ClickOutsideDirective,
    IssueSelectionComponent,
    MarkLocationComponent,
    OperationOrRejectReasonSelectionComponent,
    DefectiveFlowContainerComponent,
    DefectiveFlowContainerV3Component,
    RangeComponentComponent,
    TooltipComponent,
    ViewMoreListModalComponent,
    StatusHeaderComponent,
    AccordionTableComponent,
    TableRowPopoverComponent,
    InlineSingleSelectComponent,
    InlineMultiSelectDeprComponent,
    MultiSelectDropdownComponent,
    ListingLayoutComponent,
    DropdownComponent,
    CalendarComponent,
    EditableListComponent,
    BctxSelectionComponent,
    FilterMasterdataListComponent,
    BleModeComponent,
    LoaderOverlayComponent,
    TimelineComponent,
    StatusTileComponent,
    SearchbarWithAPISuggestionsContainerComponent,
    BulkCountLandingComponent,
    BulkCountGradingPageComponent,
    VendorSelectionComponent,
    GradingPageExitComponent,
    ValidationErrorModalComponent,
    MultiSelectPopoverComponent,
    InlineMultiSelectComponent,
    SilhouetteComponent,
    SilhouetteMarkerComponent,
    TagDisplayComponent,
    TagHistoryModalComponent,
    IssueCategoryFilterComponent,
    RejectSelectionV2Component,
    RejectV2MultiSelectComponent,
    FilterRejectV2ListComponent,
    AppUpdatesComponent,
    InspectionCompletionSuccessPopupComponent,
    EnterTagModalComponent,
    LineSelectionModalComponent,
    LinesComponent,
    UpdateQtyModalComponent,
    BundleTagDetailsComponent,
    ExpandBundleTagDetailsModalComponent,
    GroupedBctxListingComponent,
    LoginBackgroundComponent,
    BulkActionComponent,
    MobileListingPaginationComponent,
    SingleAndMultiSelectComponent,
    DateFilterComponent,
    NpsFormComponent,
    IncreaseDecreaseInputComponent,
    AppUpdateModalComponent,
  ],
})
export class UiModule {}
